import { Injectable } from '@angular/core';

import { ServerResponseDto } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {
  public log(error: Error): void {
    console.groupCollapsed(`uncaught error`);
    console.error(`error: ${error.name}`);
    console.error(`error: ${error.message}`);
    console.error(`error: ${error.stack}`);
    console.groupEnd();
  }

  public isServerResponse(err: unknown): err is ServerResponseDto {
    if (typeof err !== 'object' || err === null) {
      return false;
    }

    const partialResponse = err as Partial<ServerResponseDto>;

    const hasMessage = 'message' in partialResponse && typeof partialResponse.message === 'string';
    const hasSuccess = 'success' in partialResponse && typeof partialResponse.success === 'boolean';

    return hasMessage && hasSuccess;
  }
}
